<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog" v-if="controller">
        <v-card>
            <div class="common-text text-center mb-6">
                Вы действительно хотите перезагрузить <br> контроллер?
            </div>
            <div class="main-text text-center mb-5">
                <v-flex xs12>
                    <v-checkbox
                        v-model="force"
                        label="Жёсткая перезагрузка"
                        dense
                    ></v-checkbox>
                </v-flex>
            </div>
            <v-flex class="d-flex justify-end">
                <v-btn class="btn-grey main-text" @click="cancel">
                    Отмена
                </v-btn>
                <v-btn class="btn-gradient main-text" @click="reboot(force)">
                    ОК
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalRebootController",
    props: {
        value: {
            type: Boolean,
        },
        controller: {
            type: Object,
        },
        close: {
            type: Function,
            default: () => {},
        },
        reboot: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            dialog: false,
            force: false,
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        cancel() {
            this.dialog = false;
            if (this.close) {
                this.close();
            }
            this.$emit('input', false);
        },
    }

}
</script>

<style lang="scss" scoped>
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 125px;
}
</style>